export default __webpack_public_path__ + "static/media/bg.1aa51c39.jpg";